export default "__VITE_ASSET__DeGzs9Jx__"